export default __webpack_public_path__ + "static/media/img_selected-industry-hospitality.dbd7ecd9.svg";